import React from "react";
import { Link } from "react-router-dom";
import { Star, ShoppingCart, Tag } from "lucide-react";

export default function CourseCard({ course, onBuyNow }) {
  const cleanSlug = (course.slug || "").trim();

  return (
    <div
      data-testid={`course-card-${cleanSlug}`}
      className="lift-card group flex flex-col rounded-2xl overflow-hidden bg-[#161B24] border border-white/10 h-full"
    >
      <Link to={`/courses/${cleanSlug}`} className="block relative">
        <div className="aspect-[16/9] overflow-hidden bg-slate-800">
          <img
            src={course.thumbnail_url}
            alt={course.title}
            className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
            loading="lazy"
          />
        </div>
        <div className="absolute top-3 left-3 flex gap-2">
          <span className="red-pill text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
            {course.category}
          </span>
        </div>
      </Link>

      <div className="p-5 flex-1 flex flex-col">
        <Link to={`/courses/${cleanSlug}`}>
          <h3 className="font-display font-bold text-white text-base leading-snug line-clamp-2 hover:text-amber-300 transition">
            {course.title}
          </h3>
        </Link>
        <p className="text-xs text-slate-400 mt-1.5">By {course.instructor}</p>

        <p className="text-sm text-slate-300 mt-3 line-clamp-2 flex-1">
          {course.short_description}
        </p>

        <div className="flex items-center gap-1 mt-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} size={12} className="text-amber-400" fill="currentColor" strokeWidth={0} />
          ))}
          <span className="text-xs text-slate-400 ml-1">
            ({course.reviews?.length || 0}+ Reviews)
          </span>
        </div>

        <div className="mt-4 flex items-center justify-between">
          <div>
            <span className="text-slate-500 line-through text-xs mr-2">{course.original_price}</span>
            <span className="gold-text font-display font-extrabold text-xl">{course.price}</span>
          </div>
          <button
            data-testid={`course-buy-now-${course.slug}`}
            onClick={(e) => {
              e.preventDefault();
              onBuyNow && onBuyNow(course);
            }}
            className="flex items-center gap-1.5 text-xs font-semibold px-3.5 py-2 rounded-lg bg-gradient-to-r from-[#E50914] to-[#B91C1C] text-white hover:brightness-110 transition"
          >
            <ShoppingCart size={14} /> Buy Now
          </button>
        </div>

        {course.tags && course.tags.length > 0 && (
          <div className="mt-3 flex flex-wrap gap-1.5">
            {course.tags.slice(0, 3).map((t) => (
              <span key={t} className="inline-flex items-center gap-1 text-[10px] text-slate-400 bg-white/5 px-2 py-0.5 rounded">
                <Tag size={9} /> {t}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
